import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Timer.module.scss";
import PathContext from "../../context/path";
import StatesContext from "../../context/states";
import Btn from '../Btn';
const Timer = (props) => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const { timerShown, btnTexts, currentPartId, updateTimeline, restartTrigger, transitionJump } = props;
  const { isMobile, videoSound, updateTheme } = states;
  const [isTutor, setTutor] = useState(true);
  const [isEnd, setEnd] = useState(false);
  const [isAnswerSelected, setAnswerSelected] = useState(false);
  const [startTimer, setStartTimer] = useState(false);
  const [timeNumber, setTimeNumber] = useState(5);
  const [activeBtnId, setActiveBtnId] = useState(-1);
  const refWrap = useRef(null);
  const audioRef = useRef();
  const refTimeCircle = useRef(null);
  const refTutor = useRef(null);
  const refWarning = useRef(null);


  useEffect(() => {

    audioRef.current = new Audio(`${path}/media/tick.mp3`);
    audioRef.current.volume = 1;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        audioRef.current.volume = 0;
      } else {
        audioRef.current.volume = 1;
      }
    });
  }, [path]);


  useEffect(() => {
    const dasharray = 62 * 3.14 * 2;
    refTimeCircle.current.style.strokeDasharray = dasharray;
    refTimeCircle.current.style.strokeDashoffset = dasharray + (dasharray * timeNumber / 5);
  }, [timeNumber]);


  useEffect(() => {
    let timer1, timer2;
    const wrap = refWrap.current;
    if (timerShown) {
      wrap.classList.add(styles.active);
      setTimeNumber(5);
      setEnd(false);
      if (isTutor && currentPartId === 0) {
        refTutor.current.classList.add(styles.shown);
        timer1 = setTimeout(() => {
          setStartTimer(true);
          setTutor(false);
          refTutor.current.classList.remove(styles.shown);
        }, 3000);
      } else {
        refTutor.current.classList.remove(styles.shown);
        timer2 = setTimeout(() => {
          if (currentPartId === 6) {
            setEnd(true);
          } else {
            setStartTimer(true);
          }
        }, 300);
      }
    } else {
      clearTimeout(timer1);
      clearTimeout(timer2);
      wrap.classList.remove(styles.active);
      refTutor.current.classList.remove(styles.shown);
    }
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    }
  }, [currentPartId, isTutor, timerShown]);


  useEffect(() => {
    if (audioRef.current === null) return;
    if (videoSound) {
      audioRef.current.muted = false;
    } else {
      audioRef.current.muted = true;
    }
  }, [videoSound]);


  useEffect(() => {
    let timer;
    let playPromise;
    if (startTimer) {
      let time = 5;
      if (audioRef.current !== null) {
        audioRef.current.currentTime = 0;
        playPromise = audioRef.current.play();
      }
      timer = setInterval(() => {
        time -= 0.01;
        if (time <= 0) {
          time = 0;
          clearInterval(timer);
          setEnd(true);
          if (playPromise !== undefined) {
            playPromise.then(() => {
              audioRef.current.pause();
            })
          }
        }
        setTimeNumber(time);
      }, 10);
    } else {
      if (playPromise !== undefined) {
        playPromise.then(() => {
          audioRef.current.pause();
        })
      }
      clearInterval(timer);
    }
    return () => {
      clearInterval(timer);
      if (playPromise !== undefined) {
        playPromise.then(() => {
          audioRef.current.pause();
        })
      }
    }
  }, [path, startTimer]);


  useEffect(() => {
    setStartTimer(false);
  }, [currentPartId]);


  useEffect(() => {
    if (isEnd && currentPartId === 0) {
      refWarning.current.classList.add(styles.shown);
    } else {
      refWarning.current.classList.remove(styles.shown);
    }
    if (currentPartId === btnTexts.length - 1) {
      refWrap.current.classList.add(styles.finish);
    } else {
      refWrap.current.classList.remove(styles.finish);
    }
  }, [btnTexts, currentPartId, isEnd]);


  useEffect(() => {
    const wrap = refWrap.current;
    if (transitionJump) {
      wrap.classList.add(styles.jump);
    } else {
      wrap.classList.remove(styles.jump);
    }
  }, [transitionJump]);


  const clickHandler = (id) => {
    if (isAnswerSelected) return;
    setActiveBtnId(id);
    setAnswerSelected(true);
    let time = 10;
    setStartTimer(false);
    if (isMobile) {
      time = 500;
    }
    setTimeout(() => {
      setActiveBtnId(-1);
      updateTimeline();
      if (isMobile && currentPartId === 3) {
        updateTheme('white');
      }
    }, time);
    setTimeout(() => {
      setAnswerSelected(false);
    }, 1000);
  }

  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={`${styles.time}  ${styles[`time_${currentPartId}`] !== undefined ? styles[`time_${currentPartId}`] : ''}`}>
          <div className={styles.time__number}>{Math.floor(timeNumber)}</div>
          <div className={styles.time__circle}>
            <svg width="124" height="124" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="62" cy="62" r="60" stroke="white" strokeWidth="2" ref={refTimeCircle} />
            </svg>
          </div>
        </div>
        <div className={styles.tutor} ref={refTutor}>
          <div className={styles.tutor__svg}>
            {isMobile ?
              <svg width="347" height="40" viewBox="0 0 347 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M343.354 0.146447C343.158 -0.0488155 342.842 -0.0488155 342.646 0.146447L339.464 3.32843C339.269 3.52369 339.269 3.84027 339.464 4.03553C339.66 4.2308 339.976 4.2308 340.172 4.03553L343 1.20711L345.828 4.03553C346.024 4.2308 346.34 4.2308 346.536 4.03553C346.731 3.84027 346.731 3.52369 346.536 3.32843L343.354 0.146447ZM4.35355 0.146447C4.15829 -0.0488155 3.84171 -0.0488155 3.64645 0.146447L0.464466 3.32843C0.269204 3.52369 0.269204 3.84027 0.464466 4.03553C0.659728 4.2308 0.976311 4.2308 1.17157 4.03553L4 1.20711L6.82843 4.03553C7.02369 4.2308 7.34027 4.2308 7.53553 4.03553C7.7308 3.84027 7.7308 3.52369 7.53553 3.32843L4.35355 0.146447ZM323 38.5H220V39.5H323V38.5ZM343.5 19V0.5H342.5V19H343.5ZM323 39.5C334.322 39.5 343.5 30.3218 343.5 19H342.5C342.5 29.7696 333.77 38.5 323 38.5V39.5ZM24 39.5H127V38.5H24V39.5ZM4.5 19V0.5H3.5V19H4.5ZM24 38.5C13.2304 38.5 4.5 29.7696 4.5 19H3.5C3.5 30.3218 12.6782 39.5 24 39.5V38.5Z" fill="white" />
              </svg>
              :
              <svg width="505" height="8" viewBox="0 0 505 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM1 4.5H201V3.5H1V4.5Z" fill="white" />
                <path d="M504.354 3.64645C504.549 3.84171 504.549 4.15829 504.354 4.35355L501.172 7.53553C500.976 7.7308 500.66 7.7308 500.464 7.53553C500.269 7.34027 500.269 7.02369 500.464 6.82843L503.293 4L500.464 1.17157C500.269 0.976311 500.269 0.659728 500.464 0.464466C500.66 0.269204 500.976 0.269204 501.172 0.464466L504.354 3.64645ZM504 4.5H300V3.5H504V4.5Z" fill="white" />
              </svg>
            }

          </div>
          <div className={styles.tutor__mouse}>
            <svg width="29" height="48" viewBox="0 0 29 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0933 28.04L11.0933 9.75C11.1227 9.25417 11.3356 8.78703 11.6905 8.43952C12.0454 8.09201 12.5169 7.889 13.0133 7.87V7.87C13.5203 7.86876 14.0089 8.06015 14.3802 8.40545C14.7515 8.75076 14.9778 9.2242 15.0133 9.73L15.6233 21.94" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12.8334 40.59C12.4034 35.39 2.65336 27.44 1.15336 25.5C1.08156 25.4093 1.033 25.3025 1.01191 25.1888C0.990814 25.075 0.997821 24.9579 1.03232 24.8475C1.06682 24.7371 1.12776 24.6368 1.20986 24.5553C1.29195 24.4738 1.3927 24.4137 1.50336 24.38C2.27266 24.1289 3.09097 24.0659 3.88963 24.1964C4.68829 24.3269 5.44401 24.6471 6.09336 25.13L10.0934 28.04" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15.5435 20.26C15.5744 19.6856 15.8159 19.1428 16.2217 18.7351C16.6275 18.3275 17.1692 18.0836 17.7435 18.05V18.05C18.3159 18.0138 18.8799 18.2027 19.3151 18.5763C19.7503 18.9499 20.0225 19.4787 20.0735 20.05L20.1935 21.45" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M20.1733 20.66C20.3664 20.4126 20.6097 20.2089 20.8872 20.0624C21.1647 19.9158 21.4701 19.8298 21.7833 19.81V19.81C22.3547 19.774 22.9175 19.9631 23.3512 20.3369C23.7848 20.7108 24.0548 21.2395 24.1033 21.81V22.16" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M24.1934 22.22C24.536 21.8495 25.0095 21.6271 25.5134 21.6V21.6C25.7696 21.5679 26.0297 21.5895 26.2772 21.6635C26.5246 21.7374 26.7539 21.8621 26.9505 22.0296C27.1471 22.197 27.3067 22.4035 27.4191 22.6361C27.5315 22.8686 27.5943 23.1219 27.6034 23.38C28.0934 27 26.1534 34.5 25.7034 40.59" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M26.3535 40.59H10.7935V47.26H26.3535V40.59Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
              <circle opacity="0.3" cx="12.5933" cy="8" r="8" fill="white" />
            </svg>

          </div>
          <div className={styles.tutor__text}>Чтобы сделать выбор — кликай на понравившийся вариант</div>
        </div>
        <div className={styles.warning} ref={refWarning}>
          Пора решаться! <br />
          Кликай по одному из вариантов
        </div>
        {currentPartId === 6 ?
          <div className={styles.desc}>Примите участие в рейтинге работодателей России</div>
          :
          null
        }
        <div className={`${styles.btns} ${styles[`btns_${currentPartId}`] !== undefined ? styles[`btns_${currentPartId}`] : ''}`}>
          {btnTexts[currentPartId].map((element, index) => {
            if (currentPartId === 6) {
              return <a href="https://rating.hh.ru" className={`${styles.btn} ${styles.btn_end}`} key={`btn-${index}-${currentPartId}`}>
              <div className={styles.btn__inner}>
                <Btn text={element} size={'final'} flash={isEnd} delay={500 * index} arrow={true} />
              </div>
            </a>
            } else {
              return <div className={styles.btn} key={`btn-${index}-${currentPartId}`} onClick={() => clickHandler(index)}>
                <div className={styles.btn__inner}>
                  <Btn text={element} size={currentPartId === 6 ? 'final' : 'medium'} flash={isEnd} delay={500 * index} isActive={activeBtnId === index ? true : false} />
                </div>
              </div>
            }
          })}
        </div>
        {currentPartId === 6 ?
          <>
            <div className={styles.links} >
              <a href={`https://t.me/share/url?url=${window.location.origin}${window.location.pathname}`} target='_blank' rel='noreferrer' className={styles.link}>
                <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M6.32519 15.4654L16.2841 9.18285C16.7816 8.88041 17.2379 9.0431 16.8619 9.37532L8.33429 17.0691L8.00318 20.6104L6.3243 15.4654H6.32519ZM19.1503 6.1098L1.43362 12.9436C0.224958 13.4285 0.231182 14.1034 1.21363 14.4034L5.63118 15.7836L7.3223 20.9658C7.52741 21.5333 7.42608 21.7584 8.0223 21.7584C8.20044 21.7562 8.37575 21.7137 8.5351 21.634C8.69444 21.5544 8.83368 21.4397 8.94231 21.2985C9.10475 21.1396 10.0712 20.1985 11.1512 19.1496L15.7474 22.546C16.5919 23.0127 17.2036 22.7708 17.4141 21.7608L20.4316 7.54359C20.7403 6.30603 19.959 5.74355 19.1503 6.11089V6.1098Z" fill="white" />
                </svg>

              </a>
              <a href={`https://connect.ok.ru/offer?url=${window.location.origin}${window.location.pathname}`} target='_blank' rel='noreferrer' className={styles.link}>
                <svg width="21" height="30" viewBox="0 0 21 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9811 4.48438C8.00788 4.48438 5.59766 6.90704 5.59766 9.89544C5.59766 12.8839 8.00788 15.3067 10.9811 15.3067C13.9544 15.3067 16.3646 12.8839 16.3646 9.89544C16.3646 6.90704 13.9544 4.48438 10.9811 4.48438ZM10.9811 12.1324C9.75208 12.1324 8.75571 11.1309 8.75571 9.89552C8.75571 8.66019 9.75208 7.65871 10.9811 7.65871C12.2101 7.65871 13.2065 8.66019 13.2065 9.89552C13.2065 11.1309 12.2101 12.1324 10.9811 12.1324Z" fill="white" />
                  <path d="M12.8834 19.6123C15.0386 19.171 16.3301 18.1452 16.3984 18.0901C17.0291 17.5817 17.1304 16.6558 16.6246 16.0218C16.1189 15.3879 15.1977 15.2861 14.5669 15.7944C14.5536 15.8052 13.1761 16.8673 10.9096 16.8689C8.64326 16.8673 7.23665 15.8052 7.22332 15.7944C6.59251 15.2861 5.67133 15.3879 5.16563 16.0218C4.65986 16.6558 4.76117 17.5817 5.39183 18.0901C5.46109 18.1459 6.80591 19.1985 9.02153 19.6295L5.93365 22.8731C5.37249 23.458 5.38936 24.3894 5.97133 24.9535C6.25538 25.2288 6.62147 25.3656 6.98726 25.3656C7.37077 25.3656 7.7539 25.215 8.04111 24.9155L10.9097 21.844L14.0681 24.9354C14.6403 25.5097 15.567 25.5088 16.1382 24.9338C16.7094 24.3588 16.7087 23.4272 16.1366 22.8531L12.8834 19.6123Z" fill="white" />
                  <path d="M10.9109 16.8693C10.9084 16.8693 10.9132 16.8694 10.9109 16.8694C10.9085 16.8694 10.9133 16.8693 10.9109 16.8693Z" fill="white" />
                </svg>

              </a>
              <a href={`https://vk.com/share.php?url=${window.location.origin}${window.location.pathname}`} target='_blank' rel='noreferrer' className={styles.link}>
                <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M20.5263 1.57301C20.6763 1.1079 20.5263 0.769245 19.8701 0.769245H17.689C17.4857 0.758196 17.284 0.811633 17.1128 0.921833C16.9415 1.03203 16.8094 1.19348 16.7352 1.38312C16.0533 2.99228 15.1477 4.49707 14.0452 5.85307C13.5377 6.36062 13.3039 6.53056 13.029 6.53056C12.8801 6.53056 12.6901 6.36063 12.6901 5.89552V1.55348C12.6901 1.00348 12.5201 0.748629 12.0539 0.748629H8.62276C8.55311 0.745352 8.48352 0.755937 8.41802 0.779824C8.35252 0.803712 8.29241 0.840448 8.24122 0.887789C8.19003 0.93513 8.14878 0.992126 8.11986 1.05557C8.09094 1.11901 8.07493 1.18757 8.07276 1.25726C8.07276 1.78592 8.85632 1.91348 8.93943 3.39593V6.61601C8.93943 7.31467 8.81321 7.44107 8.53699 7.44107C7.79565 7.44107 5.99566 4.70972 4.91477 1.59661C4.70233 0.981722 4.49098 0.749307 3.93987 0.749307H1.73743C1.10232 0.749307 0.996094 1.04544 0.996094 1.36278C1.5736 4.01799 2.75496 6.50454 4.44855 8.62949C5.16165 9.77983 6.13919 10.7432 7.29982 11.4394C8.46046 12.1356 9.77061 12.5446 11.1212 12.6322C12.5185 12.6322 12.6885 12.3146 12.6885 11.7846V9.81574C12.6885 9.17952 12.8148 9.07328 13.2599 9.07328C13.5774 9.07328 14.1499 9.2435 15.4423 10.4935C16.9248 11.9757 17.1799 12.6533 18.0048 12.6533H20.1861C20.8223 12.6533 21.1194 12.3359 20.9485 11.7219C20.4843 10.7696 19.8623 9.90265 19.1088 9.15792C18.6001 8.56414 17.8374 7.90798 17.605 7.58931C17.2874 7.16554 17.3725 6.99677 17.605 6.61411C18.746 5.03658 19.7251 3.34817 20.5274 1.57423" fill="white" />
                </svg>
              </a>
            </div>
            <div className={styles.restart} onClick={restartTrigger}>Посмотреть ещё раз
              {isMobile ?
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M19.9591 17.0057C22.0023 13.4775 21.2723 8.38642 16.9783 5.91477C13.5106 3.91876 10.3137 5.4902 8.79503 6.43134L10.9633 7.67938C11.1288 7.77466 11.2496 7.9316 11.2991 8.11567C11.3485 8.29973 11.3226 8.49585 11.2271 8.66088C11.1315 8.82591 10.9741 8.94633 10.7895 8.99565C10.6048 9.04497 10.4081 9.01915 10.2426 8.92387L6.49777 6.76836C6.33224 6.67308 6.21145 6.51614 6.16198 6.33208C6.11251 6.14801 6.13841 5.95189 6.23398 5.78686L8.39605 2.0534C8.49162 1.88837 8.64904 1.76795 8.83366 1.71863C9.01829 1.66931 9.21501 1.69513 9.38054 1.79041C9.54607 1.88569 9.66686 2.04263 9.71633 2.22669C9.7658 2.41076 9.7399 2.60688 9.64433 2.77191L8.33772 5.02816C10.1116 3.98834 13.7469 2.39549 17.699 4.67028C22.7707 7.58956 23.5965 13.5987 21.2074 17.7242C18.8183 21.8496 13.1855 24.1412 8.11378 21.2219C5.68714 19.8252 4.22236 17.7044 3.629 15.4181C3.31528 14.203 3.24031 12.9388 3.4082 11.6953C3.42083 11.6018 3.45181 11.5117 3.49937 11.4301C3.54693 11.3485 3.61014 11.2771 3.68539 11.2198C3.76064 11.1626 3.84647 11.1207 3.93796 11.0966C4.02944 11.0724 4.12481 11.0665 4.21861 11.0791C4.31241 11.0917 4.4028 11.1225 4.48462 11.17C4.56645 11.2174 4.63811 11.2804 4.6955 11.3554C4.7529 11.4304 4.79491 11.516 4.81914 11.6072C4.84337 11.6984 4.84934 11.7935 4.83672 11.887C4.69365 12.9462 4.75732 14.023 5.02422 15.058C5.52281 16.9877 6.7561 18.7811 8.83447 19.9775C13.1285 22.4491 17.916 20.5338 19.9591 17.0057Z" fill="white" />
                </svg>
                :
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M13.8471 11.834C15.2646 9.37884 14.7581 5.83598 11.779 4.11598C9.3732 2.72698 7.15528 3.82053 6.10165 4.47546L7.60594 5.34396C7.72078 5.41026 7.80458 5.51947 7.8389 5.64756C7.87323 5.77565 7.85526 5.91213 7.78895 6.02697C7.72265 6.14181 7.61344 6.22561 7.48535 6.25993C7.35726 6.29425 7.22078 6.27629 7.10594 6.20998L4.50787 4.70998C4.39302 4.64368 4.30922 4.53447 4.2749 4.40638C4.24058 4.27829 4.25855 4.14181 4.32485 4.02697L5.82485 1.42889C5.89116 1.31405 6.00037 1.23025 6.12846 1.19593C6.25654 1.16161 6.39302 1.17958 6.50787 1.24588C6.62271 1.31219 6.70651 1.42139 6.74083 1.54948C6.77515 1.67757 6.75718 1.81405 6.69088 1.92889L5.78438 3.499C7.01506 2.77539 9.53718 1.66695 12.279 3.24995C15.7977 5.28145 16.3706 9.46315 14.7131 12.334C13.0556 15.2049 9.14768 16.7996 5.62902 14.7681C3.94546 13.7961 2.92924 12.3202 2.51757 10.7293C2.29992 9.88367 2.24791 9.00395 2.36439 8.13859C2.37315 8.07352 2.39464 8.0108 2.42764 7.95403C2.46063 7.89727 2.50449 7.84755 2.5567 7.80773C2.60891 7.76791 2.66845 7.73876 2.73192 7.72195C2.79539 7.70514 2.86156 7.701 2.92663 7.70976C2.99171 7.71852 3.05442 7.74001 3.11119 7.77301C3.16796 7.806 3.21767 7.84986 3.25749 7.90207C3.29731 7.95428 3.32646 8.01382 3.34327 8.07729C3.36008 8.14076 3.36422 8.20693 3.35546 8.272C3.25621 9.00907 3.30038 9.75838 3.48555 10.4787C3.83146 11.8215 4.68709 13.0696 6.12902 13.9021C9.10815 15.6221 12.4296 14.2892 13.8471 11.834Z" fill="white" />
                </svg>
              }
            </div>
          </>
          :
          null
        }
      </div>
    </>
  );

}

export default Timer;
